import React, { useState } from 'react';
import { useQuery, useMutation } from '@tanstack/react-query';
import {
  fetchTimeOffHistory,
  fetchVacationExtraOrUsedBalance,
} from '../../../store/apis/leaveService';
import { ModalWrapper, ModalTable } from '../../../components/Common';
import { VACATION_LEAVES_TYPES } from './constants';

import './TimeOffHistory.scss';

export default function TimeOffHistory() {
  const [isModelOpen, setIsModalOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    title: 'Modal Title',
    dataConfig: null,
    data: [],
  });
  // Fetch Time Off History
  const { data: timeOffHistoryData } = useQuery({
    queryKey: ['timeOffHistory'],
    queryFn: () => fetchTimeOffHistory({}),
    keepPreviousData: true,
    enabled: true,
  });

  const { mutate: vacationExtraOrUsedBalanceMutation } = useMutation({
    mutationFn: vacationParams =>
      fetchVacationExtraOrUsedBalance({
        type: vacationParams,
      }),
    onSuccess: (dataResponse, params) => {
      if (params === VACATION_LEAVES_TYPES['Annual Leave']) {
        setModalConfig(prev => ({
          ...prev,
          title: 'Details of Annual Leave',
          data: dataResponse,
        }));
        setIsModalOpen(true);
      }
      if (params === VACATION_LEAVES_TYPES['Birthday Leave']) {
        setModalConfig(prev => ({
          ...prev,
          title: 'Details of Birthday Leave',
          data: dataResponse,
        }));
        setIsModalOpen(true);
      }
      if (params === VACATION_LEAVES_TYPES['Casual Leave']) {
        setModalConfig(prev => ({
          ...prev,
          title: 'Details of Casual Leave',
          data: dataResponse,
        }));
        setIsModalOpen(true);
      }
      if (params === VACATION_LEAVES_TYPES['Hajj Leave']) {
        setModalConfig(prev => ({
          ...prev,
          title: 'Details of Hajj Leave',
          data: dataResponse,
        }));
        setIsModalOpen(true);
      }
      if (params === VACATION_LEAVES_TYPES['Maternity/Paternity Leave']) {
        setModalConfig(prev => ({
          ...prev,
          title: 'Details of Maternity/Paternity Leave',
          data: dataResponse,
        }));
        setIsModalOpen(true);
      }
      if (params === VACATION_LEAVES_TYPES['Sick Leave']) {
        setModalConfig(prev => ({
          ...prev,
          title: 'Details of Sick Leave',
          data: dataResponse,
        }));
        setIsModalOpen(true);
      }
      if (params === VACATION_LEAVES_TYPES['Study Leave']) {
        setModalConfig(prev => ({
          ...prev,
          title: 'Details of Study Leave',
          data: dataResponse,
        }));
        setIsModalOpen(true);
      }
      if (params === VACATION_LEAVES_TYPES['Unpaid Leave']) {
        setModalConfig(prev => ({
          ...prev,
          title: 'Details of Unpaid Leave',
          data: dataResponse,
        }));
        setIsModalOpen(true);
      }
      if (params === VACATION_LEAVES_TYPES['Other Time off']) {
        setModalConfig(prev => ({
          ...prev,
          title: 'Details of Other Time off',
          data: dataResponse,
        }));
        setIsModalOpen(true);
      }
    },
  });

  const handleVacationTypeModalClick = type => {
    if (!type) return;
    vacationExtraOrUsedBalanceMutation(type);
  };

  return (
    <div className="mx-3 mb-3">
      <span className="tnc-title" style={{ letterSpacing: '1px' }}>
        Time Off History
      </span>
      <div className="mt-1">
        {timeOffHistoryData?.map(item => {
          const [value, labelPart] = item.TIMEOFF.split(':');
          const label = labelPart.replace('days of ', '').trim();
          return (
            <div
              onClick={() =>
                handleVacationTypeModalClick(VACATION_LEAVES_TYPES[label])
              }
              className="d-flex gap-1 flex-wrap mb-1"
            >
              <span className="time-off-vacation-number cursor-pointer">
                {parseFloat(value.trim()).toFixed(1)}
              </span>
              <span className="fw-semibold text-dark">:</span>
              <span className="ms-1 fw-semibold">{label}</span>
            </div>
          );
        })}
      </div>
      <ModalWrapper
        isModalOpen={isModelOpen}
        toggle={() => setIsModalOpen(!isModelOpen)}
        title={modalConfig?.title}
        onButtonClick={() => setIsModalOpen(false)}
        buttonText="Close"
        size="xl"
      >
        <ModalTable
          data={modalConfig?.data}
          dataConfig={modalConfig?.dataConfig}
        />
      </ModalWrapper>
    </div>
  );
}
